let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dYQOj")).then(() => parcelRequire('dGr1q'));